import * as React from 'react';
import { useField } from 'react-final-form';
import Input from '../../../../../Input';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';

const Fields: React.FunctionComponent = () => {
	const { t } = useTranslation('Loyalty');
	const theme = useTheme('Loyalty').LoyaltyConnect;

	const numberField = useField('loyaltyNumber', {
		type: 'text',
		validate: value => {
			if (!value || (value && value.length < 4)) {
				return 'Please enter your card number';
			}

			return undefined;
		}
	});

	const passwordField = useField('loyaltyPassword', {
		type: 'password',
		validate: value => {
			if (!value || (value && value.length < 4)) {
				return 'Enter password';
			}

			return undefined;
		}
	});

	return (
		<>
			<div className={theme.group__field}>
				<Input
					label={t('Card number')}
					absoluteHintPosition={true}
					value={numberField.input.value}
					TextFieldProps={{
						...numberField.input,
						helperText:
							((numberField.meta.error && numberField.meta.touched) || numberField.meta.submitFailed) &&
							t(numberField.meta.error || numberField.meta.submitError),
						error:
							((numberField.meta.error && numberField.meta.touched) || numberField.meta.submitFailed) &&
							(!!numberField.meta.error || !!numberField.meta.submitError)
					}}
				/>
			</div>

			<div className={theme.group__field}>
				<Input
					label={t('Password')}
					value={passwordField.input.value}
					absoluteHintPosition={true}
					TextFieldProps={{
						...passwordField.input,
						helperText:
							((passwordField.meta.modified && passwordField.meta.touched) ||
								passwordField.meta.submitFailed) &&
							t(passwordField.meta.error),
						error:
							((passwordField.meta.error && passwordField.meta.touched) ||
								passwordField.meta.submitFailed) &&
							(!!passwordField.meta.error || !!passwordField.meta.submitError)
					}}
				/>
			</div>
		</>
	);
};

export default Fields;
